/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomerApiService } from './customer-api.service';

@Injectable({
  providedIn: 'root',
})
export class AlertApiService {
  constructor(private api: CustomerApiService) {}

  // SCORE/EVENT ALERTS

  getAlerts(type: string): Observable<any> {
    return this.api.get('/v1/alerts', { alert_type: type });
  }

  addAlert(data: any): Observable<any> {
    return this.api.post('/v1/alerts', data);
  }

  removeAlert(uid: string): Observable<any> {
    return this.api.delete('/v1/alerts/' + uid);
  }

  setIndicator(alert: boolean, iparams: any): Observable<any> {
    const endpoint = alert
      ? '/v1/investment_ratio_alerts/activate'
      : '/v1/investment_ratio_alerts/deactivate';
    return this.api.get(endpoint, {
      sector: iparams.id,
      strategy: iparams.overlay,
    });
  }
}
